import * as React from "react"
import * as Yup from "yup"
import { Formik } from "formik"
import {
  Modal,
  ModalCard,
  StyledModal,
  StyledModalHeader,
  StyledModalActions,
  StyledModalBody,
  Button,
  Text,
  InputConnectedField,
} from "gatsby-interface"

const validationSchema = Yup.object().shape({
  siteNameInput: Yup.string()
    .required("Email is required")
    .test(
      "siteNameMatch",
      "Please make sure your input matches the site name.",
      function (value) {
        const { siteName } = this.parent
        return siteName === value
      }
    ),
})

export type DataLayerApiConfirmationModalProps = {
  siteName: string
  isOpen: boolean
  onDismiss: () => void
  onConfirm: () => void
}

export function DataLayerApiConfirmation({
  siteName,
  isOpen,
  onDismiss,
  onConfirm,
}: DataLayerApiConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      aria-label={`Disable the GraphQL API`}
      onDismiss={onDismiss}
      type="error"
    >
      <ModalCard>
        <StyledModal variant="WARNING">
          <StyledModalHeader onCloseButtonClick={onDismiss}>
            Disable the GraphQL API?
          </StyledModalHeader>

          <StyledModalBody>
            <Text>
              Are you sure you want to disable the <b>{siteName}</b> Content Hub
              GraphQL API?
            </Text>
            <Formik
              initialValues={{ siteNameInput: ``, siteName }}
              validationSchema={validationSchema}
              onSubmit={onConfirm}
              validateOnMount={true}
            >
              {({ isSubmitting, isValid }) => (
                <form>
                  <InputConnectedField
                    name="siteNameInput"
                    label="Site name:"
                    required
                    data-cy="delete-site-name-input"
                  />
                  <StyledModalActions>
                    <Button
                      type="button"
                      onClick={onDismiss}
                      tone="NEUTRAL"
                      variant="SECONDARY"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      onClick={onConfirm}
                      tone="DANGER"
                      variant="PRIMARY"
                      loading={isSubmitting}
                      disabled={isSubmitting || !isValid}
                    >
                      Disable API
                    </Button>
                  </StyledModalActions>
                </form>
              )}
            </Formik>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
